// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Un-z","badgeLink":"Vn-z","category":"Wn-z"};